import { selector, waitForAll } from 'recoil';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import {
    allCoverablesToCoverableDTOArray,
    getCoverageRequestItems
} from '../../utils/coverablesUtil';
import _ from 'lodash';
import { singleHippoCoverageTextSelector } from './singleHippoCoverageTextSelector';

export const allHippoCoverageTextsSelector = selector({
    key: 'allHippoCoverageTextsSelector',
    get: ({ get }) => {
        const allCoverables = get(allCoverablesAtom);
        const coverableList = allCoverablesToCoverableDTOArray(allCoverables);

        let requestItems = coverableList.flatMap((coverable: CoverableDTO) =>
            getCoverageRequestItems(
                coverable.termIds ?? [],
                coverable.coverages?.map((cov) => cov.type ?? '') ?? []
            )
        );

        requestItems = _.uniqWith(requestItems, (request1, request2) =>
            _.isEqual(request1, request2)
        );

        const coverageTextItems = get(
            waitForAll(requestItems.map(singleHippoCoverageTextSelector))
        ).flat(1);

        return coverageTextItems;
    }
});
